import { render, staticRenderFns } from "./ResultsUnitTableInline.vue?vue&type=template&id=97607b9c&scoped=true&"
import script from "./ResultsUnitTableInline.vue?vue&type=script&lang=js&"
export * from "./ResultsUnitTableInline.vue?vue&type=script&lang=js&"
import style0 from "./ResultsUnitTableInline.vue?vue&type=style&index=0&id=97607b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97607b9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
